import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Tag } from "lucide-react";
import { PrescriptionHeader } from "./components/prescription-header";
import { UserInfoSection } from "./components/user-info-section";
import { PrescriptionDetailsSection } from "./components/prescription-details-section";
import { PrescriptionTags } from "./components/prescription-tags";
import { PrescriptionActions } from "./components/prescription-actions";
import { PrescriptionOrder } from "../types/prescription";

interface PrescriptionCardItemProps {
  prescription: PrescriptionOrder;
}

export function PrescriptionCardItem({
  prescription,
}: PrescriptionCardItemProps) {
  // Check if prescription has been sent (only check wati_message_id)
  const isSent = !!prescription.wati_message_id;

  // Can send if not already sent and status allows it
  const canSend =
    !isSent &&
    (prescription.status === "PENDING" ||
      prescription.status === "UNMATCHED_DRUGS" ||
      prescription.status === "FAILED" ||
      prescription.status === "PROCESSED");

  return (
    <Card>
      <PrescriptionHeader prescription={prescription} />
      <CardContent>
        <div className="grid grid-cols-2 gap-4">
          <UserInfoSection prescription={prescription} />
          <PrescriptionDetailsSection prescription={prescription} />
        </div>
        <PrescriptionTags tags={prescription.tags} />
        {prescription.order_summary?.discountAmount !== undefined && (
          <div className="mt-3">
            <Badge className="gap-1.5 bg-green-100 text-green-700 border border-green-300 hover:bg-green-100">
              <Tag className="h-3 w-3" />
              Men&apos;s Health Discount Applied
            </Badge>
          </div>
        )}
        <PrescriptionActions
          prescriptionId={prescription.id}
          isSent={isSent}
          canSend={canSend}
          tags={prescription.tags}
        />
      </CardContent>
    </Card>
  );
}
